import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { ArrowLeftIcon, XIcon } from 'lucide-react-native';
import { Pressable, View } from 'react-native';

export function PulseSwipeHintBanner({ onDismiss }: { onDismiss: () => void }) {
  return (
    <Pressable
      accessibilityHint="Hides this Pulse swipe tip permanently"
      accessibilityLabel="Dismiss Pulse swipe tip"
      accessibilityRole="button"
      className="mx-5 rounded-[22px] border border-primary/20 bg-primary/10 px-4 py-3 active:opacity-90"
      onPress={onDismiss}>
      <View className="flex-row items-center gap-3">
        <View className="size-9 items-center justify-center rounded-full bg-primary/15">
          <Icon as={ArrowLeftIcon} size={17} className="text-primary" />
        </View>
        <View className="min-w-0 flex-1 gap-0.5">
          <Text className="text-[14px] font-semibold text-foreground" numberOfLines={1}>
            Swipe alerts to tune or dismiss
          </Text>
          <Text variant="small" className="text-muted-foreground" numberOfLines={2}>
            Open options or clear what you do not need. This tip disappears after your first swipe.
          </Text>
        </View>
        <View className="size-8 items-center justify-center rounded-full bg-surface-alt/80">
          <Icon as={XIcon} size={14} className="text-muted-foreground" />
        </View>
      </View>
    </Pressable>
  );
}
